export var PLANNING_STATUS = {
  WITHIN: "Within Range",
  UNDER: "Under Target",
  OUT: "Out of Range",
};

export function nutritionStateLabel(state) {
  if (state === "WITHIN_RANGE") return PLANNING_STATUS.WITHIN;
  if (state === "UNDER_TARGET") return PLANNING_STATUS.UNDER;
  if (state === "OUT_OF_RANGE") return PLANNING_STATUS.OUT;
  return null;
}

// Prefer the backend's authoritative three-state judgement, calculated from
// unrounded saved totals with the planner's rounding. The totals/ranges path is
// only backward compatibility for an older response lacking nutrition_state.
export function savedDayStatusLabel(status) {
  if (!status || status.targets_ready !== true) return null;
  var authoritative = nutritionStateLabel(status.nutrition_state);
  if (authoritative) return authoritative;
  if (
    !status.target ||
    !status.committed_totals ||
    !status.ranges ||
    !status.ranges.on_track
  )
    return null;
  var under = false;
  var macros = ["calories", "protein", "carbs", "fat"];
  for (var i = 0; i < macros.length; i++) {
    var key = macros[i];
    var target = Number(status.target[key]);
    var actual = Number(status.committed_totals[key]);
    var band = status.ranges.on_track[key];
    if (!(target > 0) || !Number.isFinite(actual) || !band) return null;
    var pct = Math.round((actual / target) * 100);
    if (pct > band[1]) return PLANNING_STATUS.OUT;
    if (pct < band[0]) under = true;
  }
  if (under) return PLANNING_STATUS.UNDER;
  return PLANNING_STATUS.WITHIN;
}
